import {
  CustomRoute,
  getPillar3aFullHtmlTitle,
  Page,
  Pillar3aFunnelStepNumber,
  Type,
} from "src/app/shared/routes/shared/shared-route.constant";
import { extractQueryStringParametersResolver } from "../../shared/resolvers/extract-query-string-parameters.resolver";
import { funnelHeaderMilestonesResolver } from "../../shared/resolvers/get-funnel-header-milestones.resolver";

import { allPillar3aFunnelHeaderMilestones } from "src/app/shared/routes/global-route.constant";
import { projectionPagePath } from "src/app/shared/routes/quote/pillar-3a/quote-route.constant";
import { Product } from "src/app/shared/store/shared/product";

export const quotePillar3aRoutes: CustomRoute[] = [
  {
    path: projectionPagePath,
    loadComponent: async () =>
      (await import("../pages/projection/projection.page")).ProjectionPage,
    data: {
      type: Type.PRODUCT_SPECIFIC,
      page: Page.QUOTE_3A_PROJECTION,
      product: Product.PILLAR_3A_CONSTANT,
      htmlTitle: getPillar3aFullHtmlTitle($localize`Sparplan`),
      pageTitle: $localize`Ihr 3a Sparplan`,
      pageSubtitle: $localize`Mögliche Wertentwicklung Ihres Altersguthabens.`,
      funnelHeaderMilestones: allPillar3aFunnelHeaderMilestones,
      navigation: {},
      dataAnalytics: {
        funnelStepNumber: Pillar3aFunnelStepNumber.QUOTE_3A_PROJECTION,
      },
    },
    resolve: {
      funnelHeaderMilestones: funnelHeaderMilestonesResolver,
      extractQueryStringParametersResolver,
    },
  },
];
